export const CANONICAL_AI_ENGINEERING_COURSE_ID = 'ai-engineering';

export const AI_ENGINEERING_LEGACY_COURSE_IDS = [
  'ai-engineering-mit-vibe-coding-und-agentic-ai',
  'vibe-coding-agentic-ai',
] as const;

const COURSE_ID_ALIASES = new Map<string, string>(
  AI_ENGINEERING_LEGACY_COURSE_IDS.map((legacyId) => [
    legacyId,
    CANONICAL_AI_ENGINEERING_COURSE_ID,
  ]),
);

export function normalizeCourseId(courseId: string | null | undefined): string {
  const trimmed = courseId?.trim() ?? '';
  if (!trimmed) {
    return CANONICAL_AI_ENGINEERING_COURSE_ID;
  }
  return COURSE_ID_ALIASES.get(trimmed) ?? trimmed;
}

export function isLegacyCourseId(courseId: string | null | undefined): boolean {
  const trimmed = courseId?.trim() ?? '';
  return COURSE_ID_ALIASES.has(trimmed);
}

export function courseIdStorageAliases(courseId: string): readonly string[] {
  const normalized = normalizeCourseId(courseId);
  if (normalized !== CANONICAL_AI_ENGINEERING_COURSE_ID) {
    return [normalized];
  }
  return [
    CANONICAL_AI_ENGINEERING_COURSE_ID,
    ...AI_ENGINEERING_LEGACY_COURSE_IDS,
  ];
}
